import React, { useEffect, useLayoutEffect, useRef, useState } from "react"
import { Box, Container, Heading, Text, Flex } from "theme-ui"
import { useInView } from "react-intersection-observer"
import gsap from "gsap"
import { ScrollTrigger } from "gsap/dist/ScrollTrigger"
import { useBreakpointIndex } from "@theme-ui/match-media"

gsap.registerPlugin(ScrollTrigger)

const NumberInsights = ({ block }) => {
  const mediaIndex = useBreakpointIndex()
  const numbersInsightsRef = useRef()
  const numbersContainerRef = useRef([])

  useEffect(() => {
    if (numbersContainerRef.current[numbers.length - 1]) {
      const numberElem = numbersContainerRef.current[numbers.length - 1]

      // console.log("numbersContainerRef", numbersContainerRef.current)
      gsap.set(".number_section_2", {
        position: "sticky",
      })
      setTimeout(() => {
        const numerContainerOne = numbersContainerRef.current[0]
        const numerContainerTwo = numbersContainerRef.current[1]
        const numerContainerThree = numbersContainerRef.current[2]

        let tl = gsap.timeline()

        tl.to(numerContainerOne, {
          scrollTrigger: {
            trigger: numerContainerOne,
            start: "top -10%",
            endTrigger: numerContainerThree,
            scroller: "body",

            scrub: true,
            pin: true,
            onLeave: () => {
              numerContainerOne.style.opacity = "0"
            },
            onEnterBack: () => {
              numerContainerOne.style.opacity = "1"
            },
          },
          y: "100%",
          x: "-20%",
          scale: mediaIndex > 1 ? 20 : 30,
          ease: "power4.in"
        })

        tl.to(numerContainerTwo, {
          scrollTrigger: {
            trigger: numerContainerTwo,
            start: "top -10%",
            endTrigger: numerContainerThree,
            scroller: "body",

            scrub: true,
            pin: true,
            onLeave: () => {
              numerContainerTwo.style.opacity = "0"
            },
            onEnterBack: () => {
              numerContainerTwo.style.opacity = "1"
            },
          },
          y: "100%",
          x: "-20%",
          scale: mediaIndex > 1 ? 20 : 30,
          ease: "power4.in"
        })

        tl.to(numerContainerThree, {
          scrollTrigger: {
            trigger: numerContainerThree,
            start: "top -10%",
            endTrigger: document.querySelector("#intro_home"),
            scroller: "body",
            scrub: true,
            pin: true,
            onLeave: () => {
              numerContainerThree.style.display = "none"
            },
            onEnterBack: () => {
              numerContainerThree.style.display = "sticky"
            },
          },
          y: "80%",
          scale: mediaIndex > 1 ? 10 : 25,
          ease: "power4.in"
        })
      }, 1000)
    }
  }, [])

  const [selected, setSelected] = useState(0)
  const { title, numbers } = block
  return (
    <Box
      className="numbers_insight_container"
      sx={{
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Container
        sx={{
          position: "relative",
        }}
      >
        <Heading
          as="h2"
          variant="h2"
          sx={{
            mb: [3, 4, 4, 4],
            mt: 0,
            pt: [8, 8],
            color: "primary",
            textTransform: "uppercase",
          }}
        >
          {title}
        </Heading>
        {numbers &&
          numbers.map((number, index) => (
            <Box
              key={number + index}
              ref={ref => {
                numbersContainerRef.current[index] = ref
              }}
              className={`number_section_${index}`}
              sx={{
                width: "100%",
                width: "100%",
                height: "100vh",
                position: "relative",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Number
                number={number}
                index={index}
                selected={selected === index}
              />
            </Box>
          ))}
      </Container>
    </Box>
  )
}

const Number = ({ number, index, selected }) => {
  const [startCount, setStartCount] = useState(false)
  const [ref, inView] = useInView()

  useEffect(() => {
    if (inView === true && startCount === false) {
      setStartCount(true)
    }
  }, [inView])

  return (
    <Flex
      className="number"
      ref={ref}
      sx={{
        justifyContent: "center",
        alignItems: "center",
        marginBottom: [2],
        flexDirection: "column",
      }}
    >
      <Box>
        <Text
          sx={{
            marginTop: 0,
            marginBottom: 0,
            color: "primary",
            opacity: 1,
            fontSize:
              index > 1 ? ["25vw", "30vw", "30vw"] : ["40vw", "40vw", "40vw"],
            lineHeight: 1,
            transition: "opacity .3s ease-in-out",
          }}
        >
          {number.prefix + number.float}
        </Text>
      </Box>
      <Flex
        sx={{
          alignItems: "center",
        }}
      >
        <Text
          as="p"
          sx={{
            fontFamily: "roc",
            fontSize: [4, 4, 4, 5],
            textAlign: "right",
            color: "primary",
          }}
        >
          {number.legend}
        </Text>
      </Flex>
    </Flex>
  )
}

export default NumberInsights
